import Header from '../../components/Header';
import Footer from '../../components/Footer';
import MobileAppUsage from './components/MobileAppUsage';
import DeviceUsage from './components/DeviceUsage';
import CoreFeatures from './components/CoreFeatures';
import ProblemStatement from './components/ProblemStatement';
import PurchasePoint from './components/PurchasePoint';
import Contact from './components/Contact';
import BusinessChart from './components/BusinessChart';
import Disaster from './components/Disaster';
import AppDownload from './components/AppDownload';
import CoreProblemStatement from './components/CoreProblemStatement';
import { useEffect, useState } from 'react';
import VideoContainer from './components/VideoContainer';

export default function MainPage() {

  const [headerStyle, setHeaderStyle] = useState('white');

  useEffect(() => {
    const handleScroll = () => {
      setHeaderStyle(window.scrollY < window.innerHeight ? 'white' : 'normal');
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <div>
      <Header headerStyle={headerStyle}/>
      <main>
        <section className='relative py-[200px] px-[10%] lg:py-[300px] w-full h-screen'>
          <img 
            src={`${process.env.REACT_APP_STATIC_URL}/images/main/Hero_Section_Background.jpg`} 
            alt='배경'
            className='absolute inset-0 w-full h-screen object-cover object-center z-[-2]'
          />

          <div className='absolute inset-0 w-full h-screen bg-black opacity-15 z-[-1]'/>
          
          <h1 className='font-bold text-title1 lg:text-[68px] text-white'>
            장애인과 고령자의 안전을 위한<br/>
            주행 사고 자동 신고 솔루션
          </h1>

          <img 
            className='w-[110px] lg:w-[200px] mt-[25px]'
            src='logo_white.png'
          />
        </section>

        <CoreProblemStatement />

        <ProblemStatement />

        <CoreFeatures/>

        <BusinessChart />        

        <DeviceUsage/>

        <MobileAppUsage />

        <Disaster />

        <PurchasePoint/>

        <VideoContainer/>

        <Contact />

        <AppDownload/>
      </main>
      <Footer/>
    </div>
  )
}